import React from "react"
import { OrderShippingNshift } from "lib/types/generated/graphql-types"
import { ReactComponent as NshiftLogo } from "images/providers/nshift-logo.svg"
import CopyButton from "components/Ui/CopyButton"
import ListEntry from "../../../../../components/Order/Ui/ListEntry"
import { Container, CopyWrapper, Row, Title } from "./Styled"

type Props = {
  shippingNshift: OrderShippingNshift | undefined
}

const NshiftDetails = ({ shippingNshift }: Props) => {
  if (!shippingNshift?.preparedShipment) return null

  const { preparedShipment } = shippingNshift

  return (
    <>
      <Title $logoMargin={"0 0.8rem 0.7rem 0.4rem"}>
        <NshiftLogo /> details
      </Title>
      <Container>
        <Row>
          <CopyWrapper>
            <ListEntry label={"Reference"} value={shippingNshift?.reference} />
            <CopyButton string={shippingNshift?.reference} />
          </CopyWrapper>
          <CopyWrapper>
            <ListEntry label={"Order No"} value={preparedShipment?.orderNo} />
            <CopyButton string={preparedShipment?.orderNo} />
          </CopyWrapper>
        </Row>
        <Row>
          <CopyWrapper>
            <ListEntry label={"Prepare ID"} value={preparedShipment?.prepareId} />
            <CopyButton string={preparedShipment?.prepareId} />
          </CopyWrapper>
          <ListEntry label={"Service name"} value={preparedShipment?.service?.name ?? "-"} />
        </Row>
        <Row>
          <ListEntry label={"Service title"} value={preparedShipment?.service?.title ?? "-"} />
          <ListEntry label={"Service ID"} value={preparedShipment?.service?.id ?? "-"} />
        </Row>
        <Row>
          <ListEntry
            label={"Source System"}
            value={preparedShipment?.service?.sourceSystem ?? "-"}
          />
          <div />
        </Row>
        {preparedShipment.sender && (
          <>
            <Row>
              <ListEntry label={"Sender Name"} value={preparedShipment.sender.name ?? "-"} />
              <ListEntry label={"Sender Address"} value={preparedShipment.sender.address1 ?? "-"} />
            </Row>
            <Row>
              <ListEntry label={"Sender City"} value={preparedShipment.sender.city ?? "-"} />
              <ListEntry label={"Sender Zip Code"} value={preparedShipment.sender.zipCode ?? "-"} />
            </Row>
            <Row>
              <ListEntry label={"Sender Country"} value={preparedShipment.sender.country ?? "-"} />
              <ListEntry label={"Sender Email"} value={preparedShipment.sender.email ?? "-"} />
            </Row>
          </>
        )}
        {preparedShipment.agent && (
          <>
            <Row>
              <ListEntry label={"Agent Name"} value={preparedShipment.agent.name ?? "-"} />
              <ListEntry label={"Agent Address"} value={preparedShipment.agent.address1 ?? "-"} />
            </Row>
            <Row>
              <ListEntry label={"Agent City"} value={preparedShipment.agent.city ?? "-"} />
              <ListEntry label={"Agent Zip Code"} value={preparedShipment.agent.zipCode ?? "-"} />
            </Row>
            <Row>
              <ListEntry label={"Agent Country"} value={preparedShipment.agent.country ?? "-"} />
              <ListEntry label={"Agent Quick ID"} value={preparedShipment.agent.quickId ?? "-"} />
            </Row>
          </>
        )}
      </Container>
    </>
  )
}

export default NshiftDetails
